<template>
  <div class="main_center resultNoticeList" style="padding: 18px;">
    <div class="content" style="padding: 0 16px;">
      <div class="search-content">
        <div class="mainBtn" style="padding: 0;">
          <el-button
            @click="routerAdd"
            size="small"
            type="primary"
            v-if="hasBtnPermission('btn_portalCreditSystem_add')"
            >新增</el-button
          >
        </div>
      </div>

      <el-table
        :data="tableData"
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        border
        stripe
        :height="tableMaxHeight"
      >
        <el-table-column
          fixed
          label="序号"
          type="index"
          width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="标题"
          prop="title"
          fixed
          header-align="center"
          align="left"
          min-width="200"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          header-align="center"
          align="center"
          min-width="170"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="创建人"
          prop="createUser"
          header-align="center"
          align="center"
          min-width="170"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="是否发布"
          prop="updateTime"
          header-align="center"
          align="center"
          min-width="170"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.submitFlag ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发布时间"
          prop="submitTime"
          header-align="center"
          align="center"
          min-width="170"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="detailSingle(scope.row.id)"
              v-if="hasBtnPermission('btn_portalCreditSystem_detail')"
              >查看</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="changeSingle(scope.row.id)"
              v-if="hasBtnPermission('btn_portalCreditSystem_edit') && !scope.row.submitFlag"
              >修改</el-button
            >
            <el-button
              type="text"
              size="small"
              title="删除"
              @click="deleteById(scope.row)"
              v-if="hasBtnPermission('btn_portalCreditSystem_delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <paginationCom
        @sizechange="sizeChangeHandle"
        @pagechange="pageChangeHandle"
        class="limit"
        :options="paginationOpt"
      ></paginationCom>
    </div>
  </div>
</template>

<script>
import { getPortalSystemListData, deletePortalSystemListData } from "@/server/mainCredit.js";
export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 200 - 106,

      paginationOpt: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 50],
      },
      tableData: [],
    };
  },
  activated() {
    this.getData();
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 获取列表数据
      getPortalSystemListData({
        page: this.paginationOpt.pageIndex,
        rows: this.paginationOpt.pageSize,
      }).then((res) => {
        this.tableData = res.data.rows;
        this.paginationOpt.total = res.data.total;
      });
    },
    // 每页长度改变
    sizeChangeHandle(value) {
      this.paginationOpt.pageSize = value;
      this.paginationOpt.pageIndex = 1;
      this.getData();
    },
    // 当前页改变
    pageChangeHandle(value) {
      this.paginationOpt.pageIndex = value;
      this.getData();
    },
    indexMethod(index) {
      return (
        (this.paginationOpt.pageSize - 1) *
          Number(this.paginationOpt.pageSize) +
        Number(index) +
        1
      );
    },
    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletePortalSystemListData(item.id).then((res) => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },

    routerAdd() {
      this.$router.push({
        name: "portalCreditSystemAdd",
      });
    },

    detailSingle(id) {
      this.$router.push({
        name: "portalCreditSystemDetail",
        query: { id },
      });
    },

    changeSingle(id) {
      this.$router.push({
        name: "portalCreditSystemEdit",
        query: { id },
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
